import { render } from "./pwd.html?vue&type=template&id=790f041e&external"
import script from "./pwd.js?vue&type=script&lang=js&external"
export * from "./pwd.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__